/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {ScorecardTable} from '../styles';
import {Utils} from '../../../../utils/api';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
import {ColumnContainerSummary, ArrowHolderSummary} from '../../../../components/Table/styles';
import {default as TableContainer} from '../tableContainer';

export default ({dataTableContent}: {dataTableContent: Array<any>}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();

  useEffect(() => {
    const newExams = dataTableContent?.filter(item => {
      if (item?.medicalAlerts?.lastFreshExamDay) {
        return item;
      } else {
        return false;
      }
    });

    useTable(newExams);
  }, [dataTableContent]);

  function changeTable(e) {
    useTable([...e]);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  const SortingTableHead = ({
    title,
    attr,
    location,
    sortFunction,
  }: {
    title?: string;
    attr?: any;
    location?: any;
    sortFunction: Function;
  }) => {
    return (
      <th onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </th>
    );
  };

  return (
    <TableContainer title={'Medical Alerts'} numberOfPlayers={table.length} subTitle="Any arm feels tight or sore">
      <ScorecardTable>
        <thead>
          <tr>
            <SortingTableHead
              title="Last Fresh Exam Day"
              attr="lfed"
              location={['medicalAlerts', 'lastFreshExamDay']}
              sortFunction={toggleSortString}
            />
            <SortingTableHead title="Reason" attr="reason" location={['medicalAlerts', 'reason']} sortFunction={toggleSortString} />
          </tr>
        </thead>
        <tbody>
          {table?.length > 0 ? (
            table?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{(item?.medicalAlerts?.lastFreshExamDay !== undefined || item?.medicalAlerts?.lastFreshExamDay !== null) ? item?.medicalAlerts?.lastFreshExamDay : '-'}</td>
                  <td>{(item?.medicalAlerts?.reason !== undefined || item?.medicalAlerts?.reason !== null) ? item?.medicalAlerts?.reason : '-'}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={2}>No Data</td>
            </tr>
          )}
        </tbody>
      </ScorecardTable>
    </TableContainer>
  );
};
